import React from "react";
import "./MobileRestriction.css";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { persistor, resetStore } from "../../store";
import { authService } from "../../api/authApi";
import { clearAuth } from "../../_redux/AuthSlice";
import Cookies from "js-cookie";

const MobileRestriction = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    const themeSettings = localStorage.getItem("themeSettings");
    try {
      await authService.logout();
    } catch (err) {
      console.error("Logout error:", err);
    } finally {
      dispatch(clearAuth());
      dispatch(resetStore());
      await persistor.flush();
      await persistor.purge();
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem("themeSettings", themeSettings);
      navigate("/ats/login");
    }
  };

  return (
    <div className="mobile-restriction-container">
      <div className="mobile-restriction-content">
        <div className="mobile-restriction-logo">
          <img
            src={process.env.PUBLIC_URL + "/assests/img/Hirewing-logo.png"}
            alt="HireWing Logo"
          />
        </div>
        <div className="mobile-restriction-illustration">
          <img
            src={process.env.PUBLIC_URL + "/assests/mobileviewSignout.svg"}
            alt="Mobile access restriction"
          />
        </div>
        <div className="mobile-restriction-text">
          <p>
            You're currently on a mobile device. For complete access to all
            features and a smoother experience, please continue on a desktop or
            laptop.
          </p>
        </div>
        <div className="mobile-restriction-action">
          <Button
            variant="outlined"
            className="signout-btn"
            onClick={handleLogout}
          >
            Sign Out
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MobileRestriction;
